import React, { useState } from "react";
import EditCategoryItemComponent from "../../components/EditCategoryItem";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import {
  getCategoryItemDetail,
  putCategoryItem,
} from "../../../../../services/Handlers/MasterCategoryItemService";
import { useHistory } from "react-router-dom";
import { getParams } from "../../../../../utils/utils";
import LoadingSection from "../../../../components/LoadingSection";
import { safeGoBack } from "../../../../utils/navigation";

export default function EditCategoryItem() {
  const notification = useNotification();
  const localize = useLocalization();
  const history = useHistory();
  const id = getParams("id");

  const [initialValues, setInitialValues] = useState({});

  const { isLoading, isFetching } = useQuery(
    ["CategoryItemDetail"],
    () => getCategoryItemDetail(id),
    {
      enabled: !!id,
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = res.data;
          setInitialValues({
            name: response.name,
          });
        }
      },
    }
  );

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    putCategoryItem,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successEditData"));
          setTimeout(() => safeGoBack(history, "/category-item"), 0);
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: (res) => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmit = (value) => {
    const data = {
      name: value.name,
      id,
    };
    mutateSubmit(data);
  };

  if (isLoading || isFetching) {
    return <LoadingSection />;
  }

  return (
    <EditCategoryItemComponent
      handleSubmit={handleSubmit}
      isLoadingSubmit={isLoadingSubmit}
      initialValues={initialValues}
    />
  );
}
